import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { API_ENDPOINT } from './endpoints';
import { SearchEngineModel } from 'app/models/shared/search-engine.model';
import { tVendor } from 'app/types/vendor.type';
import { SearchResponseModel } from 'app/models/shared';

@Injectable()
export class VendorService {
    constructor(private apiService: ApiService) {

    }

    
  searchVendors(searchRequest: SearchEngineModel) {
    return this.apiService.post<SearchResponseModel<tVendor>>(
      `${API_ENDPOINT.Vendor}`,
      searchRequest
    );
  }

  getVendor(vendorId: string) {
    return this.apiService.get<tVendor>(`${API_ENDPOINT.Vendor}/${vendorId}`);
  }

  createVendorInline(vendor_name: string, organization_id?: string) {
    // POST /api/vendors — backend auto-uses IMPORTED + Manual org when no organization_id
    const body: Record<string, string> = { vendor_name };
    if (organization_id) {
      body['organization_id'] = organization_id;
    }
    return this.apiService.post<tVendor>('api/vendors', body);
  }
}
